// Level system — futuristic clearance tiers
export const LEVELS = [
  { min: 0,      name: "Lab Cadet",            emoji: "🧪", color: "rgba(0,229,255,0.2)" },
  { min: 500,    name: "Junior Researcher",    emoji: "🔬", color: "rgba(74,222,128,0.2)" },
  { min: 2500,   name: "Brain Engineer",       emoji: "🧠", color: "rgba(255,46,147,0.2)" },
  { min: 7500,   name: "Heart Pilot",          emoji: "🫀", color: "rgba(255,94,58,0.2)" },
  { min: 15000,  name: "Loop Operator",        emoji: "⚖️", color: "rgba(168,85,247,0.2)" },
  { min: 30000,  name: "Galactic Reader",      emoji: "🪐", color: "rgba(255,198,41,0.2)" },
  { min: 60000,  name: "Mensa-in-Training",    emoji: "🎓", color: "rgba(255,198,41,0.3)" },
  { min: 120000, name: "Sean's Inner Circle",  emoji: "👑", color: "rgba(255,46,147,0.3)" },
];

export function getLevelInfo(xp) {
  let level = LEVELS[0];
  let next = LEVELS[1];
  for (let i = 0; i < LEVELS.length; i++) {
    if (xp >= LEVELS[i].min) {
      level = LEVELS[i];
      next = LEVELS[i + 1] || null;
    }
  }
  const progress = next ? Math.min(1, (xp - level.min) / (next.min - level.min)) : 1;
  return { level, next, progress, xp };
}

// Friendly status — neon colors for dark theme
export function getLoopStatus(brain, heart) {
  if (brain === 0 && heart === 0) return { emoji: "✨", text: "Log your first session!", color: "#fff" };
  if (heart === 0) return { emoji: "⏱️", text: "Add minutes!", color: "#ff5e3a" };
  if (brain === 0) return { emoji: "📖", text: "Add words!", color: "#ff2e93" };
  const ratio = brain / 50 / heart;
  if (Math.abs(1 - ratio) <= 0.25) return { emoji: "🟢", text: "Balanced Loop!", color: "#4ade80" };
  if (ratio > 1.25) return { emoji: "🟡", text: "Slow down — soak it in", color: "#ffc629" };
  return { emoji: "🔵", text: "Speed up — read more!", color: "#00e5ff" };
}
